module.exports = __webpack_public_path__ + "static/img/img_about.bcdf023.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_about.png
// module id = 1Lz5
// module chunks = 1